"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiDivider = getMuiDivider;
function getMuiDivider(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      middle: {
        margin: '0 24px'
      },
      root: {
        borderColor: palette.grey[300]
      }
    }
  };
}